<template>
  <div class="business-evaluation">
    <div class="business-evaluation.header">
      <el-input
        placeholder="请输入项目名称"
        v-model="params.projectName"
        class="input-with-select"
        @keyup.enter.native="search"
        clearable
        @clear="search"
      >
        <el-button slot="append" icon="el-icon-search" @click="search"></el-button>
      </el-input>
      <label style="margin-right:10px;line-height:40px;min-width:60px;">审核状态:</label>
      <el-select v-model="params.status" placeholder="请选择" @change="search">
        <el-option :value="''" label="全部"></el-option>
        <el-option :value="0" label="待审核"></el-option>
        <el-option :value="1" label="审核中"></el-option>
        <el-option :value="2" label="已退回"></el-option>
        <el-option :value="6" label="待用户确认"></el-option>
        <el-option :value="4" label="待上传终极查新报告"></el-option>
        <el-option :value="5" label="已完成"></el-option>
      </el-select>
      <label style="margin-right:10px;line-height:40px;min-width:60px;">申请时间:</label>
      <el-date-picker
        v-model="params.startDate"
        type="date"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        placeholder="开始日期"
        @change="search"
        style="width: 10%; margin: 0 5px 0 10px"
      ></el-date-picker>
      <span>-</span>
      <el-date-picker
        v-model="params.endDate"
        type="date"
        value-format="yyyy-MM-dd"
        format="yyyy-MM-dd"
        placeholder="结束日期"
        @change="search"
        style="width: 140px; margin: 0 10px 0 5px"
      ></el-date-picker>

      <el-button type="primary" class="exportOut" icon="el-icon-download" @click="exportOut">
        导出
      </el-button>
    </div>
    <Table
      :table="table"
      :url="url"
      @editEvent="editEvent"
      @decline="decline"
      ref="children"
      :tableParams="tableParams"
    ></Table>
    <el-dialog
      v-if="drawerFrom.show"
      :visible.sync="drawerFrom.show"
      direction="rtl"
      :modal-append-to-body="false"
      :with-header="false"
      size="100%"
    >
      <upData
        ref="defaultDataRef"
        :form="drawerFrom.content"
        :type="drawerFrom.type"
        :beforeAvatarUpload="beforeAvatarUpload"
        :beforeAvatarUploadLimit="beforeAvatarUploadLimit"
        @submitForm="submitForm"
      />
    </el-dialog>
  </div>
</template>

<script>
import Cookies from "js-cookie";
import Table from "./components/Table.vue";
import upData from "./components/upData.vue";
import download from "@/utils/download";
export default {
  components: {
    Table,
    upData,
  },
  data() {
    return {
      params: {
        projectName: "",
        status: "",
      },
      visible: false,
      times: "",
      table: {
        title: "科技成果评价",
        columns: [
          { prop: "projectName", label: "项目名称" },
          { prop: "expectedCompletionDate", label: "期望完成日期" },
          { prop: "clientUnitName", label: "委托单位名称" },
          { prop: "clientContact", label: "联系人" },
          { prop: "clientPhone", label: "联系电话" },
          { prop: "createTime", label: "申请时间" },
          { prop: "status", label: "审核状态", type: "status" },
        ],
        hasBtn: true,
        hasSelect: false,
        btns: [
          {
            name: "编辑",
            event: "editEvent",
            type: "warning",
          },
        ],
      },
      //列表
      url: `${this.urlConfig.devUrl}apij2/admin-api/voucher/technology-novelty-search/page`,
      searchValue: "",
      examinationResultsSrc: [],
      id: 0,
      status: "",
      statusVal: [],
      tableParams: {
        // userId: 0
      },
      //编辑
      drawerFrom: {
        type: true,
        show: false,
        content: {},
      },
    };
  },
  created() {
    // this.tableParams.userId = JSON.parse(Cookies.get('userInfo')).id;
    if (JSON.parse(Cookies.get("userInfo")).type === 8) {
      this.tableParams.mechanism = JSON.parse(Cookies.get("userInfo")).manager_name;
    }
  },
  methods: {
    search() {
      this.$refs.children.search(this.params);
    },
    //导出
    async exportOut() {
      let url = `${urlConfig.devUrl}apij2/admin-api/voucher/technology-novelty-search/export-excel`;
      console.log("urlurlurl");
      console.log(url);
      const data = {
        ...this.params,
      };
      try {
        const response = await this.axios.post(url, data, { responseType: "blob" });
        console.log("Response data type:", response.data.type);
        console.log("Response data size:", response.data.size);
        download.excel(response.data, "业务办理-科技查新.xls");
        this.yearvisible = false;
        this.yearValue = null;
      } catch (error) {
        console.error("Download failed:", error);
      }
    },
    async editEvent(val) {
      this.drawerFrom.show = true;
      this.drawerFrom.type = false;
      let params = {
        ...val,
      };
      params.scope = params.scope ? [...params.scope.split(",")].map(Number) : [];
      params.purpose = params.purpose ? [...params.purpose.split(",")].map(Number) : [];
      this.drawerFrom.content = params;
      let url = `${this.urlConfig.devUrl}apij2/admin-api/voucher/technology-novelty-search-record/Detail?technologyNoveltySearchId=${val.id}`;
      await this.http.get(url).then(res => {
        if (res.data) {
          this.$nextTick(() => {
            this.$refs.defaultDataRef.getData(res.data, true);
          });
        }
      });
    },
    async decline(val) {
      let params = {
        ...val,
      };
      params.scope = params.scope ? [...params.scope.split(",")].map(Number) : [];
      params.purpose = params.purpose ? [...params.purpose.split(",")].map(Number) : [];
      let data = {};
      let type = true;
      console.log(params);

      if (params.status > 1) {
        let url = `${this.urlConfig.devUrl}apij2/admin-api/voucher/technology-novelty-search-record/Detail?technologyNoveltySearchId=${val.id}`;
        await this.http.get(url).then(res => {
          if (res.data) {
            data = {
              ...res.data,
            };
            type = true;
          }
        });
      } else {
        type = false;
      }
      this.drawerFrom.content = params;
      this.drawerFrom.show = true;
      this.drawerFrom.type = true;
      console.log(data);
      this.$nextTick(() => {
        this.$refs.defaultDataRef.getData(data, type);
      });
    },
    submitForm() {
      this.$refs.children.handleCurrentChange();
      this.drawerFrom.show = false;
    },
    beforeAvatarUpload(file) {
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 100MB!");
      }
      return isLt2M;
    },
    beforeAvatarUploadLimit(file) {
      if (this.examinationResultsSrc.length === 1) {
        return this.$message.warning("您已经上传了一份报告，请删除后重新上传");
      }
      const isLt2M = file.size / 1024 / 1024 < 100;
      if (!isLt2M) {
        this.$message.error("上传文件大小不能超过 100MB!");
      }
      return isLt2M;
    },
  },
};
</script>

<style lang="scss" scoped>
@include component(business-evaluation) {
  width: 100%;

  // padding: 30px;
  @include part(header) {
    width: 100%;
    text-align: left;
    display: flex;
    justify-content: flex-start;
    margin-bottom: 20px;

    .el-input {
      width: 400px;
      margin: 0 15px;
    }
  }

  @include part(step) {
    width: 100%;
    margin: 0 auto;
  }

  @include part(dialog) {
    padding: 30px 50px;
  }

  /deep/.evaluation_dialog {
    border-radius: 6px;
    .el-dialog__header {
      border-radius: 6px 6px 0 0;
      background: #fff !important;
      .header-title {
        position: relative;
        height: 100%;
        line-height: 50px;
        text-align: left;
        padding: 0 0 0 26px;
        font-weight: 600;
        font-size: 16px;

        &::before {
          content: "";
          position: absolute;
          width: 10px;
          height: 20px;
          background-color: #428dff;
          left: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
      }
    }
  }
  .el-dialog__header {
    border-radius: 6px 6px 0 0;
    background: #fff !important;
    padding: 1px 0 0 0;
    .header-title {
      display: flex;
      width: 100%;
      position: relative;
      height: 100%;
      line-height: 50px;
      text-align: left;
      padding: 0 0 0 26px;
      font-weight: 600;
      font-size: 16px;
      justify-content: space-between;

      &::before {
        content: "";
        position: absolute;
        width: 10px;
        height: 20px;
        background-color: #428dff;
        left: 0;
        top: 50%;
        transform: translate(0, -50%);
      }
      i {
        cursor: pointer;
        margin-right: 10px;
      }
    }
  }
}
</style>
